module.exports = __webpack_public_path__ + "img/ISO22000.6b43c906.jpg";